export enum SoundtrackActionEnum {
  MOVE = 'move',
  COPY = 'copy',
}
